
import React from 'react';

export const lazyWithRetry = (
    componentImport: () => Promise<any>,
    _onRetry?: () => void
) =>
    React.lazy(async () => {
        try {
            return await componentImport();
        } catch (error: any) {
            // Check if it's a chunk load error
            if (error.message && (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('Importing a module script failed'))) {
                // Prevent infinite reload loop using session storage
                const pageReloaded = window.sessionStorage.getItem('retry-lazy-refreshed');

                if (pageReloaded !== 'true') {
                    window.sessionStorage.setItem('retry-lazy-refreshed', 'true');
                    window.location.reload();
                    // We return a never-resolving promise to wait for reload
                    return new Promise(() => { });
                }
            }
            throw error;
        }
    });
